import {
  CV_NODE_SELECTED,
  CV_PREV_NODE_SELECTED,
  CV_SET_MENU_DATA,
} from './action-creator';

export const setNavData = payload => dispatch => {
  dispatch({
    type: CV_SET_MENU_DATA,
    payload,
  });
};

export const nodeSelected = payload => dispatch => {
  dispatch({
    type: CV_NODE_SELECTED,
    payload,
  });
};

export const previousNodeSelected = payload => dispatch => {
  dispatch({
    type: CV_PREV_NODE_SELECTED,
    payload,
  });
};
